module.exports = __webpack_public_path__ + "Flag-826.f9bbc4885a348eff84e4ef4155121fae.svg";